(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProgEligFacility', ProgEligFacility);

    ProgEligFacility.$inject = ['$resource', 'DateUtils'];

    function ProgEligFacility ($resource, DateUtils) {
        var resourceUrl =  'api/prog-elig-facilities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method:'PUT'
            },
           'findAllByFilter': {
                url: 'api/prog-elig-facilities/filter',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                },
                isArray: true
            }
        });
    }
})();
